let idBase = 'schreg';

export const NotificationService = {
	info:    function(msg) { return new Notification('info', msg); },
	error:   function(msg) { return new Notification('error', msg); },
	danger:  function(msg) { return new Notification('danger', msg); },
	warn:    function(msg) { return new Notification('warn', msg); },
	success: function(msg) { return new Notification('success', msg); },
	close:   function(id) { LtFramework.actions.closeNotification(id ? idBase + '-' + id : idBase); }
};

function Notification(level, msg) {
	this._level = level;
	this._msg = msg;
	this._deferred = false;
	this._dismissible = true;
	this._id = idBase;
	this._onClose = null;
	this._action = null;
	this._hasBeenTriggered = false;
}

Notification.prototype.deferred = function(isDeferred) {
	isDeferred = isDeferred === false ? false : true;
	this._deferred = isDeferred;
	this._id = idBase + '-deferred';  // Set ID to deferred to prevent it from getting overridden on the landing page
	return this;
};

Notification.prototype.dismissible = function(isDismissible) {
	isDismissible = isDismissible === false ? false : true;
	this._dismissible = isDismissible;
	if (this._hasBeenTriggered) this.trigger();
	return this;
};

Notification.prototype.level = function(level) {
	this._level = level;
	if (this._hasBeenTriggered) this.trigger();
	return this;
};

Notification.prototype.msg = function(msg) {
	this._msg = msg;
	if (this._hasBeenTriggered) this.trigger();
	return this;
};

Notification.prototype.id = function(id) {
	if (this._hasBeenTriggered) {
		this.close();
		this._id = id ? idBase + '-' + id : idBase;
		this.trigger();
	} else {
		this._id = id ? idBase + '-' + id : idBase;
	}
	return this;
};

Notification.prototype.onClose = function(onClose) {
	this._onClose = onClose;
	if (this._hasBeenTriggered) {
		$('#' + this._id + ' .close').off(); // TODO: Replace jQuery
		$('#' + this._id).on('click', '.close', this._onClose); // TODO: Replace jQuery
	}
	return this;
};

Notification.prototype.action = function(action) {
	this._action = action;
	return this;
};

Notification.prototype.close = function() {
	if (!this._hasBeenTriggered) return; // not triggered
	this._hasBeenTriggered = false;
	LtFramework.actions.closeNotification(this._id);
	return this;
};

Notification.prototype.trigger = function() {
	// eslint-disable-next-line no-console
	if (!LtFramework && !console && !console.log) return;

	var level;

	this._hasBeenTriggered = true;

	if (this._onClose) {
		if (this._hasBeenTriggered) {
			$('#' + this._id + ' .close').off(); // TODO: Replace jQuery
		}
		$('#' + this._id).on('click', '.close', this._onClose); // TODO: Replace jQuery
	}

	switch (this._level.toLowerCase()) {
		case 'info':
			level = 'createInfoNotification';
			break;
		case 'error':
		case 'danger':
			level = 'createDangerNotification';
			break;
		case 'warn':
			level = 'createWarningNotification';
			break;
		case 'success':
			level = 'createSuccessNotification';
			break;
		default:
			throw level + ' is an unknown notification level.';
	}

	if (LtFramework) {
		LtFramework.actions[level](this._msg, this._deferred, this._dismissible, this._id);
	} else {
		Helpers.log(level, this._msg);
	}
};
